module.exports = __webpack_public_path__ + "img/close.6eec4a29.svg";